import { render } from "./PointsSettings.vue?vue&type=template&id=f39d5a14&scoped=true"
import script from "./PointsSettings.vue?vue&type=script&lang=js"
export * from "./PointsSettings.vue?vue&type=script&lang=js"

import "./PointsSettings.vue?vue&type=style&index=0&id=f39d5a14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39d5a14"]])

export default __exports__